import { Link } from 'react-router-dom';
import { WHATSAPP_URL } from '../../../constants/whatsapp';

export default function WhatsAppCTASection() {
  return (
    <section className="section-padding bg-navy relative overflow-hidden">
      {/* Decorative rings */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] border border-white/5 rounded-full" />
        <div className="absolute w-[400px] h-[400px] border border-white/5 rounded-full" />
        <div className="absolute w-[200px] h-[200px] border border-white/10 rounded-full" />
      </div>

      <div className="container-max relative z-10 text-center">
        {/* Trust badge */}
        <div className="inline-flex items-center gap-2 bg-brand-green/20 border border-brand-green/40 text-brand-green text-sm font-semibold px-5 py-2.5 rounded-full mb-8">
          🇴🇲 Oman Based — Your Trusted Wholesale Gloves Partner
        </div>

        <h2 className="font-heading font-black text-white text-3xl md:text-5xl mb-3">
          Get Wholesale Pricing Now
        </h2>
        <p className="font-arabic text-white/80 text-2xl md:text-3xl font-bold mb-6" dir="rtl">
          احصل على أسعار الجملة الآن
        </p>

        <p className="text-white/85 text-base md:text-lg max-w-xl mx-auto mb-2">
          500+ clients served. Get your custom quote via WhatsApp within 24 hours.
        </p>
        <p className="font-arabic text-white/80 text-base max-w-xl mx-auto mb-10" dir="rtl">
          أكثر من 500 عميل تمت خدمتهم. احصل على عرض سعرك المخصص عبر واتساب خلال 24 ساعة.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp text-base md:text-lg px-8 py-4 rounded-full shadow-2xl hover:scale-105 transition-transform w-full sm:w-auto justify-center wa-pulse"
          >
            <i className="ri-whatsapp-line text-2xl" />
            💬 WhatsApp for Wholesale Price
          </a>
          <Link
            to="/request-quote"
            className="bg-white/10 border border-white/20 text-white font-heading font-semibold px-8 py-4 rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto flex items-center justify-center gap-2 text-base"
          >
            <i className="ri-file-list-3-line text-xl" />
            📋 Request a Quote
          </Link>
        </div>

        <p className="text-white/70 text-xs mt-8">
          omandisposables.com · Muscat, Oman · Bulk Ready
        </p>
      </div>
    </section>
  );
}
